import constant from "../const";
import i18n from "../i18n";

function createErrorDialog(errorInfo) {
  if (errorInfo != undefined) {
    const { errorMessage, errorCode } = errorInfo;
    if (errorCode !== undefined && errorCode !== "") {
      window.alert(
        `${errorMessage}\n\n${i18n.global.t(
          constant.ERROR_CODE_GUIDE
        )}\n${errorCode}`
      );
      return;
    }
  }
  window.alert(i18n.global.t(constant.COMMON_SYSTEM_ERROR_MSG));
}

export default {
  createErrorDialog,
};
